import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PaginatedApiResponse } from '../models/securepay';
import {
  mapNotificationRecord,
  NotificationApiEnvelope,
  NotificationApiRecord,
  NotificationListHttpResponse,
  SecurepayNotification,
} from './notification.model';
import { SECUREPAY_SHARED_CONFIG } from '../config/securepay-shared-config';

@Injectable({ providedIn: 'root' })
export class NotificationService {
  private readonly http = inject(HttpClient);
  private readonly sharedConfig = inject(SECUREPAY_SHARED_CONFIG);

  /**
   * GET /api/chargeback/merchant/notifications
   */
  getNotifications(
    page: number,
    pageSize: number,
  ): Observable<
    NotificationApiEnvelope<PaginatedApiResponse<SecurepayNotification[]>>
  > {
    const params = new HttpParams()
      .set('page', String(page))
      .set('pageSize', String(pageSize));

    return this.http
      .get<NotificationListHttpResponse>(
        `${this.sharedConfig.apiBaseUrl}/api/chargeback/merchant/notifications`,
        { params },
      )
      .pipe(
        map((res) => {
          const paged = res.data;
          const rows: NotificationApiRecord[] = paged?.data ?? [];
          return {
            success: res.success,
            statusCode: res.statusCode,
            message: res.message,
            data: {
              recordsTotal: paged?.recordsTotal ?? 0,
              recordsFiltered: paged?.recordsFiltered ?? 0,
              data: rows.map(mapNotificationRecord),
              pageSize: paged?.pageSize ?? pageSize,
              hasNextPage: paged?.hasNextPage ?? false,
              hasPreviousPage: paged?.hasPreviousPage ?? false,
              totalPages: paged?.totalPages ?? 0,
              pageIndex: paged?.pageIndex ?? page,
            },
          };
        }),
      );
  }
}
